
"use client";

import React from "react";

export const UserContext = React.createContext();

class UserProvider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: props.value.userData
        }

        this.setUserData = this.setUserData.bind(this)
    }

    async setUserData(values) {
        this.setState({userData: values});
    }

    render () {

        let configObject = {
            ...this.state,
            setUserData: (values) => this.setUserData(values)   
        };

        const {children} = this.props;

        return (
            <UserContext.Provider value={configObject}>
                {children}
            </UserContext.Provider>
        );
    }
}

export default  UserProvider;